import React, { Component } from "react";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { ButtonGroup } from "reactstrap"

class PaginationButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
    };
  }

  pageNext() {
    this.props.getEntries(this.state.user, this.props.size, this.props.page + 1, ...(this.props.extraArgs || []))
    this.props.setPage(this.props.page + 1)
  }
  pagePrev() {
    this.props.getEntries(this.state.user, this.props.size, this.props.page - 1, ...(this.props.extraArgs || []))
    this.props.setPage(this.props.page - 1)
  }

  render() {
    return (
      <React.Fragment>
        <ButtonGroup className="float-right">
          <button
            className={this.props.page <= 1 ? "btn btn-outline-dark disabled" : "btn btn-outline-dark"}
            disabled={this.props.page <= 1}
            onClick={(e) => this.pagePrev()}
          >
            {this.props.prevBtnLabel}
          </button>
          <button className="btn btn-dark">{this.props.page}</button>
          <button
            className={this.props.page >= this.props.totalPages ? "btn btn-outline-dark disabled" : "btn btn-outline-dark"}
            disabled={this.props.page >= this.props.totalPages}
            onClick={(e) => this.pageNext()}
          >
            {this.props.nextBtnLabel}
          </button>
        </ButtonGroup>
        <label className="text-muted mr-4">{this.props.t("Page")} {this.props.page} {this.props.t("of")} {this.props.totalPages}</label>
      </React.Fragment>
    );
  }
}
export default PaginationButtons;

